<div class="page" itemtype="https://schema.org/AboutPage">
  <div *ngIf="response.status == 1" itemprop="mainContentOfPage" itemscope itemtype="https://schema.org/WebPageElement">
  <div class="page-title" *ngIf="page.mostrar_titulo">
    <div class="container">
      <h1 itemprop="name" class="page-title-h1">{{page.titulo}}</h1>
      <h2 *ngIf="page.mostrar_subtitulo" class="page-title-h2">{{page.subtitulo}}</h2>
    </div>  
  </div>  
  <div class="page-content">
      <div class="container container-destinos animated slideInUp">
        <div class="row">
          <div class="col-md-4" *ngFor="let d of destinos">
            <destino-item [data]="d"></destino-item>
          </div>  
        </div>  
      </div>
    </div>
    <modulo posicao="whatsapp" template="fixo"></modulo> 
  </div> 
  <div *ngIf="response.status == 500"> 
    <div class="container"> 
        <page-error [data]="response.data" (reload)="getData()"></page-error>
    </div>  
  </div>  
</div>  
<loader [hidden]="!loader"></loader> 
        